import { Component, OnInit } from '@angular/core';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var getHexAscii: any;

@Component({
  selector: 'app-neft',
  templateUrl: './neft.component.html',
  styleUrls: ['./neft.component.css']
})
export class NeftComponent implements OnInit {

 userName: string;
  scoAccounts: any;
  loanAccounts: any;
  isLoad: boolean;
  payeeListRtgs: any;
  nickNameRN: any = '';
  toAccountNoRN: any;
  ifsccdRN: any;
  mobilenoRN: any;
  rtgsOrNeft: any = 'N';
  date1: any;
  isRtgsNeft: string = 'page1';
  fromAccountNoRN: any = '';
  amountRN: any;
  narrationRN: any;
  otpRN: any;
  accountNo: any;
  nextBtnDisabled:boolean=false;
  subBtnDisabled:boolean=false;

  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  //regNum = /^.*[0-9]/;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;

  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;

  fromAccountNoRNValidate: string;
  disabled: boolean;
  nickNameRNValidate: string;
  amountNotlankRtgsNeft: string;
  amountmessageForSpaceRtgsNeft: string;
  amountZeroOnlyRtgsNeft: string;
  notValidAmmountRtgsNeft: string;
  narrationValidateRN: string;
  showAcctBalance: string;
  showAllTransaction: string;
  accountInfo: any;
  transactionList: any;
  error: string = '';
  otpRNValidate: string;
  disabledSubmit: boolean;
  message: string;
  greterThanZero: string;
  rtgsMinLimit: boolean = false;
  neftMaxLimit: boolean = false;

constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    this.userName =sessionStorage.getItem('storedUserName');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    this.spinnerService.show();
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.isLoad = true;
    request.param1 = getHexAscii('', this.userName + 'rtgs/neft');
    request.param2 = this.userName;
    request.param3 = 'rtgs/neft';
    this.webService.getResponse(request, 'getAllPayee').subscribe((data: IbResponse) => {
      this.spinnerService.hide();
      response = data;
      this.isLoad = false;
      if (response !== null && response.status === 'S200')  {
        this.payeeListRtgs = response.param6;
      } else if (response !== null) {
        this.error = response.param1;
      } else {
        this.error = 'Something Went Wrong Please Contact Customer Care';
      }
    });
 
   
   
    
  }

  ngOnInit() {

   

    this.error = '';
    if (this.rtgsOrNeft) {
      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.rtgsOrNeft);
      request.param2 = this.rtgsOrNeft;
      this.webService.getResponse(request, 'isRtgsNeftOpen').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.message = response.param1;
        this.date1 = response.param3;
        if (response !== null && response.status === 'S200')  {
          if (this.message === 'N') {
            if (confirm('Your Transaction will Take place On ' + this.date1 +' '+response.param4+ ' If You Want To Proceed Press Ok') === true) {
              this.isRtgsNeft = 'page1';
          }
          }
        } else if (response !== null && data.status === 'OBJECT_NOT_FOUND' ) {
          alert(response.param1);
          alert('hhhh');
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }

        this.isLoad = false;
        this.message = response.param1;
        this.date1 = response.param3;
      });
    }

  }
  getToAccountNoRN() {
    this.error = '';
    for (let i = 0; i < this.payeeListRtgs.length; i++) {
      if (this.payeeListRtgs[i].nickname === this.nickNameRN) {
        this.toAccountNoRN = this.payeeListRtgs[i].acctno;
        this.ifsccdRN = this.payeeListRtgs[i].ifsccd;
        this.mobilenoRN = this.payeeListRtgs[i].mobileno;
      }
    }
  }

  isValidForRtgsOrNeft() {

  }

  getOtpRtgs() {
    this.error = '';
    
    this.nextBtnDisabled=true;
//    this.allValidation();
    // if (this.fromAccountNoRN && this.toAccountNoRN && this.amountRN && this.narrationRN && this.disabled === false) {
      if( this.fromAcctValidateRtgsNeft() && this.nickNameValidateRtgsNeft() && this.toAccountNoRN
       && this.validateAmountRtgsNeft() &&  this.validateNarrationRtgsNeft()){
    this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        this.isRtgsNeft='page3';
        if (response !== null && response.status === 'S200')  {
          this.isRtgsNeft = 'page2';
          this.otpRN='';
          console.log('OTP'+JSON.stringify(response.param1));
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
  
  go(){
     this.isRtgsNeft='page1';
     this.error = '';
    if (this.rtgsOrNeft) {
      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.rtgsOrNeft);
      request.param2 = this.rtgsOrNeft;
      this.webService.getResponse(request, 'isRtgsNeftOpen').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        this.message = response.param1;
        this.date1 = response.param3;
        if (response !== null && response.status === 'S200')  {
          if (this.message === 'N') {
            if (confirm('Your Fund Transfer Is Completed On ' + this.date1 + ' If You Want To Proceed Press Ok') === true) {
              this.isRtgsNeft = 'page1';
            }
          }
        } else if (response !== null && data.status === 'OBJECT_NOT_FOUND' ) {
          alert(this.message);
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  
  }

  rOnFundTransferRequest() {
    this.error = '';
    //this.subBtnDisabled=true;
    if (this.fromAccountNoRN && this.toAccountNoRN && this.amountRN && this.narrationRN && this.otpRN && this.disabled === false
      && this.getRTGSOTPValid() ) {
        console.log('otp output:-----------'+ this.getRTGSOTPValid());
     this.spinnerService.show();
      const otpRNDetails: any = {
        'userName': this.userName,
        'otp': getHexAscii('', this.otpRN),
        'rtgsOrNeft': this.rtgsOrNeft,
        'sameOrOther': this.message,
        'tranDate': this.date1,
        'creditIfscCd': this.ifsccdRN,
        'creditMobileNo': this.mobilenoRN,
        'creditNickName': this.nickNameRN
      };
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
     // request.param1 = getHexAscii('', this.fromAccountNoRN + this.toAccountNoRN + this.amountRN + this.narrationRN + this.userName + this.otpRN + this.rtgsOrNeft + this.message + this.date1 + this.ifsccdRN + this.mobilenoRN + this.nickNameRN);
     request.param1 = getHexAscii('', this.fromAccountNoRN + this.toAccountNoRN + this.amountRN + this.narrationRN + this.userName + this.otpRN + this.rtgsOrNeft + this.message  + this.ifsccdRN + this.mobilenoRN + this.nickNameRN); 
     request.param2 = this.fromAccountNoRN;
      request.param3 = this.toAccountNoRN;
      request.param4 = this.amountRN;
      request.param5 = this.narrationRN;
      request.param6 = otpRNDetails;
      this.webService.getResponse(request, 'rtgsNeftFundTransfer').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200')  {
          this.accountNo = this.fromAccountNoRN;
          //this.showTransaction();
          this.isRtgsNeft='page3';
          this.error = "Your transaction  completed successfully for Rs. "+ this.amountRN + " to account No : "+this.toAccountNoRN + "  With Reference No :" + response.param2;
        } else if (response != null && (response.status==='S333' || response.status==='S334') ) {
          this.error= response.param1;
          this.subBtnDisabled=false;
        }  else if (response !== null) {
          this.error ='Your transaction is declined for Rs.'+this.amountRN+' due to '+ response.param1;
        }  else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.subBtnDisabled=false;
        }
      });
    }
  }

  back1() {
    this.isRtgsNeft = 'NEFTpage';
    this.fromAccountNoRN = '';
    this.nickNameRN = '';
    this.toAccountNoRN = '';
    this.amountRN = '';
    this.narrationRN = '';
    this.otpRN = '';
  }

  back2() {
     this.isRtgsNeft = 'page1';
    this.nextBtnDisabled=false;
     this.otpRN = '';
  }

  allValidation() {
    this.fromAcctValidateRtgsNeft();
    if (!this.disabled) {
      this.nickNameValidateRtgsNeft();
      if (!this.disabled) {
        this.validateAmountRtgsNeft();
      } if (!this.disabled) {
        this.validateNarrationRtgsNeft();
      }
    }
  }

  showTransaction() {
    this.error = '';
    if (this.accountNo && this.accountNo !== '') {
      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.accountNo);
      request.param2 = this.accountNo;
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        this.showAcctBalance = 'hide';
        this.showAllTransaction = 'hide';
        if (response !== null && response.status === 'S200')  {
          this.accountInfo = response.param5;
          this.transactionList = response.param8;
          console.log('this.transactionList : ' + this.transactionList);
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  fromAcctValidateRtgsNeft() {
    if (this.fromAccountNoRN === undefined || this.fromAccountNoRN === '') {
      this.fromAccountNoRNValidate = 'no';
      this.disabled = true;
      return false;
    }else{
      return true;
    }
  }
  removeMessageFromAcctRtgsNeft() {
    this.fromAccountNoRNValidate = '';
    this.disabled = false;
  }
  nickNameValidateRtgsNeft() {
    if (this.nickNameRN === undefined || this.nickNameRN === '') {
      this.nickNameRNValidate = 'no';
      this.disabled = true;
      return false;

    }else{
      return true;

    }
  }
  removeMessagetoAcctRtgsNeft() {
    this.nickNameRNValidate = '';
    this.disabled = false;
  }
  validateAmountRtgsNeft() {
    if (this.amountRN === undefined || this.amountRN === '') {
      this.amountNotlankRtgsNeft = 'no';
      this.disabled = true;
      return false;
    } else if (this.amountRN.match(this.regexpspace)) {
      this.amountmessageForSpaceRtgsNeft = 'no';
      this.disabled = true;
      return false;
    } else if (this.amountRN.match(this.regZeroOnly)) {
      this.amountZeroOnlyRtgsNeft = 'no';
      this.disabled = true;
      return false;
    } else if (!this.amountRN.match(this.curRegExp)) {
      this.notValidAmmountRtgsNeft = 'no';
      this.disabled = true;
      return false;
    } else if (parseFloat(this.amountRN) <= 0) {
      this.greterThanZero = 'no';
      this.disabled = true;
      return false;
    } else if (this.rtgsOrNeft === 'R') {
      if (parseFloat(this.amountRN) <= 200000) {
        this.rtgsMinLimit = true;
        this.disabled = true;
        return false;
      }else{
        return true;

      }
    }
    else if (this.rtgsOrNeft === 'N') {
      if (parseFloat(this.amountRN) >= 200000) {
        this.neftMaxLimit = true;
        this.disabled = true;
        return false;
      }else{
        return true;

      }
    }

  }
  removeAmountRtgsNeft() {
    this.amountNotlankRtgsNeft = '';
    this.amountmessageForSpaceRtgsNeft = '';
    this.amountZeroOnlyRtgsNeft = '';
    this.notValidAmmountRtgsNeft = '';
    this.greterThanZero = '';
    this.rtgsMinLimit = false;
    this.neftMaxLimit = false;
    this.disabled = false;
  }
  validateNarrationRtgsNeft() {
    if (this.narrationRN === undefined || this.narrationRN === '') {
      this.narrationValidateRN = 'no';
      this.disabled = true;
      return false;
    }else{
      return true;
    }
  }

  removeNarrationRtgsNeft() {
    this.narrationValidateRN = '';
    this.disabled = false;
  }

  getRTGSOTPValid_Old() {
    if (this.otpRN === undefined || this.otpRN === '') {
      this.otpRNValidate = 'no';
      this.disabledSubmit = true;
    }
  }
   getRTGSOTPValid() {
    if (this.otpRN === undefined || this.otpRN === '') {
      this.otpRNValidate = 'no';
      return false;
    }else if (this.otpRN.match(this.reg)){
      this.otpRNValidate = 'specialChar';
      return false;
    }else if (!this.otpRN.match(this.regNum)) {
      this.otpRNValidate = 'num';
      return false;
    } else if (this.otpRN.length!=6) {
      this.otpRNValidate = 'len';
      return false;
    }else{
      this.otpRNValidate = '';
      return true;
    }
  }
  getRTGSmesageOTPRemove() {
    this.otpRNValidate = '';
    this.disabledSubmit = false;
    this.error='';
  }
}




// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/neft/neft.component.ts